<template>
    <fragment>
        <div v-show="ativo">
            <slot :ativo="ativo" ></slot>
        </div>
    </fragment>
</template>
<script>
export default {
  props:{
    titulo: String,
    id: String
  },
  data () {
    return {
      tabId: this.id,
      ativo: false
    }
  },
  inject: [ 'addTab', 'removeTab'],
  mounted() {
    this.addTab(this)
  },
  destroyed () {
      this.removeTab(this)
    }
}
</script>
